import { render, staticRenderFns } from "./PrestationFlightCompetitor.vue?vue&type=template&id=47815dad"
import script from "./PrestationFlightCompetitor.vue?vue&type=script&lang=js"
export * from "./PrestationFlightCompetitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports